module.exports = __webpack_public_path__ + "static/media/survey.cd471b81.svg";